import { ActionResult, Dispatch } from "../../utility/common/storeHelper"
import { wpAiConfigApi } from "../../api/controllers/wpAiConfig"
import projectsController from "../../api/controllers/projects"
import { saveNotificationError } from "../notifications/thunks"
import { GET_AI_ASSIST_CONFIG_FAILED_MESSAGE } from "../users/constants"
import { apiCallExceptionToSystemError } from "../../utility/common/apiCallExceptionToSystemError"
import { logError } from "../../utility/common/logError"
import { getAiAssistUrl } from "../../utility/aiassist/getAiAssistUrl"

export const aiAssistInit = (): ActionResult<Promise<void>> => async (dispatch: Dispatch) => {
    try {
        const result = await dispatch(wpAiConfigApi.endpoints.getWpAiConfig.initiate())
        const wpAiConfig = result.data

        if (!wpAiConfig) {
            return
        }

        const { AIAssistantDefaultProject, ViewAIAssistantUIRole, ViewAIAssistantUIByDefault, EnabledAIAssistantUI } =
            wpAiConfig

        if (
            AIAssistantDefaultProject?.length &&
            ViewAIAssistantUIRole &&
            ViewAIAssistantUIByDefault &&
            EnabledAIAssistantUI
        ) {
            const projects = await projectsController.getProjects()

            const projectExists = projects.some(project => project.id === AIAssistantDefaultProject)

            if (projectExists) {
                window.location.href = getAiAssistUrl(AIAssistantDefaultProject)
                return
            }
        }
    } catch (error) {
        const systemError = apiCallExceptionToSystemError(GET_AI_ASSIST_CONFIG_FAILED_MESSAGE, error)
        saveNotificationError(dispatch, systemError)
        logError(systemError)
    }
}
